import React from "react";
import propTypes from "prop-types";

const Header = ({
    className = "",
    text = "",
    required = false,
    children
}) => {
    return (
        <div className={`smart-header ${className}`}>
            {text && <h5 className="title">{text}</h5>}
            {children}
            {required && <div className="text-lx">
                <i className="far fa-asterisk inline-required" />
                <span>Indicates Required Fields</span>
            </div>}
        </div>
    );
};

Header.propTypes = {
    className: propTypes.string,
    text: propTypes.string,
    required: propTypes.bool,
    children: propTypes.any,
};

export default Header;
